// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%278%27%3E%3Cpath d=%27M0 0l6 8 6-8z%27 fill=%27%2398a2b3%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* RegisterSede.module.css */

.RegisterSede_page__9fOu7 {
  min-height: 100vh;
  background-color: #f0f4f8;
  padding-top: 64px;
}

/* ── Header ── */
.RegisterSede_pageHeader__mYSiM {
  background: #ffffff;
  border-bottom: 1px solid #e4e7ec;
  padding: 16px 20px;
}

.RegisterSede_headerInner__ZUzf8 {
  max-width: 900px;
  margin: 0 auto;
}

.RegisterSede_breadcrumb__RJLZf {
  font-size: 13px;
  color: #98a2b3;
  margin-bottom: 8px;
}

.RegisterSede_breadcrumb__RJLZf a {
  color: #98a2b3;
  text-decoration: none;
}

.RegisterSede_breadcrumb__RJLZf span {
  color: #344054;
  font-weight: 500;
}

.RegisterSede_headerRow__ESA1o {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 4px;
}

.RegisterSede_headerLeft__seBVr h1 {
  font-size: 1.9rem;
  font-weight: 700;
  color: #1a3a5c;
  margin: 0 0 4px;
}

.RegisterSede_headerLeft__seBVr p {
  font-size: 14px;
  color: #667085;
  margin: 0;
}

.RegisterSede_loginHint__LKQ68 {
  font-size: 14px;
  color: #667085;
  white-space: nowrap;
}

.RegisterSede_loginHint__LKQ68 a {
  color: #1a3a5c;
  font-weight: 600;
  text-decoration: none;
}

.RegisterSede_loginHint__LKQ68 a:hover {
  text-decoration: underline;
}

/* ── Stepper ── */
.RegisterSede_stepper__mgDaT {
  display: flex;
  align-items: center;
  margin-top: 16px;
}

.RegisterSede_stepItem__7JE4k {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #98a2b3;
  font-weight: 500;
}

.RegisterSede_stepItem__7JE4k.RegisterSede_active__WNBEi {
  color: #1a3a5c;
  font-weight: 600;
}

.RegisterSede_stepCircle__CD2Zd {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #d0d5dd;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  color: #98a2b3;
  background: #fff;
  flex-shrink: 0;
}

.RegisterSede_stepItem__7JE4k.RegisterSede_active__WNBEi .RegisterSede_stepCircle__CD2Zd,
.RegisterSede_stepItem__7JE4k.RegisterSede_done__Z4NWv .RegisterSede_stepCircle__CD2Zd {
  background: #2db899;
  border-color: #2db899;
  color: #fff;
}

.RegisterSede_stepLine__ddv1n {
  width: 60px;
  height: 2px;
  background: #d0d5dd;
  margin: 0 8px;
}

.RegisterSede_stepLine__ddv1n.RegisterSede_doneLine__Q9mKv {
  background: #2db899;
}

/* ── Contenido ── */
.RegisterSede_content__Q-7JS {
  max-width: 900px;
  margin: 36px auto;
  padding: 0 20px;
  box-sizing: border-box;
}

/* ── Card ── */
.RegisterSede_card__Uzi45 {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);
  padding: 32px 36px;
  box-sizing: border-box;
}

.RegisterSede_stepLabel__i9cn\\+ {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: #2db899;
  margin-bottom: 4px;
}

.RegisterSede_cardTitle__ZWZk8 {
  font-size: 1.2rem;
  font-weight: 700;
  color: #1a3a5c;
  margin-bottom: 4px;
}

.RegisterSede_cardSubtitle__ONRnT {
  font-size: 13px;
  color: #667085;
  margin-bottom: 24px;
}

/* ── Grid ── */
.RegisterSede_formGrid__NPv7b {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px 14px;
  margin-bottom: 24px;
}

.RegisterSede_formGrid2__AltT- {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px 14px;
  margin-bottom: 24px;
}

.RegisterSede_fieldFull__nTUpz {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.RegisterSede_field__pnQG1 {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.RegisterSede_fieldHalf__hFSur {
  grid-column: span 2;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

/* ── Inputs ── */
.RegisterSede_label__XoRzN {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: #667085;
}

.RegisterSede_input__UNLk8 {
  height: 40px;
  padding: 0 12px;
  border: 1.5px solid #d0d5dd;
  border-radius: 8px;
  font-size: 14px;
  color: #344054;
  background: #fff;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  transition: border-color 0.2s;
  font-family: inherit;
}

.RegisterSede_input__UNLk8:focus {
  border-color: #1a3a5c;
}

.RegisterSede_input__UNLk8::placeholder {
  color: #b0b8c4;
}

.RegisterSede_select__oKoCS {
  height: 40px;
  padding: 0 10px;
  border: 1.5px solid #d0d5dd;
  border-radius: 8px;
  font-size: 14px;
  color: #344054;
  background: #fff
    url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    no-repeat right 12px center;
  appearance: none;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  cursor: pointer;
  transition: border-color 0.2s;
  font-family: inherit;
}

.RegisterSede_select__oKoCS:focus {
  border-color: #1a3a5c;
}

/* ── Password ── */
.RegisterSede_passwordWrap__ycf3w {
  position: relative;
}

.RegisterSede_passwordWrap__ycf3w .RegisterSede_input__UNLk8 {
  padding-right: 40px;
}

.RegisterSede_eyeBtn__nxRz8 {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: #98a2b3;
  padding: 0;
  display: flex;
  align-items: center;
}

/* ── Nota ── */
.RegisterSede_required__a8s6G {
  font-size: 12px;
  color: #98a2b3;
  margin-bottom: 0;
}

/* ── Checkbox ── */
.RegisterSede_checkRow__7BgjD {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #344054;
}

.RegisterSede_checkRow__7BgjD input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #2db899;
  cursor: pointer;
  flex-shrink: 0;
}

.RegisterSede_checkRow__7BgjD a {
  color: #2db899;
  font-weight: 600;
  text-decoration: none;
}

/* ── Footer de card ── */
.RegisterSede_cardFooter__PuRqW {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 28px;
}

.RegisterSede_cardFooterRight__coD02 {
  display: flex;
  align-items: center;
  gap: 20px;
}

/* ── Botones ── */
.RegisterSede_btnBack__6Bpb4 {
  padding: 10px 20px;
  border: 1.5px solid #d0d5dd;
  border-radius: 8px;
  background: transparent;
  color: #344054;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: border-color 0.2s;
}

.RegisterSede_btnBack__6Bpb4:hover {
  border-color: #1a3a5c;
  color: #1a3a5c;
}

.RegisterSede_btnNext__lEJVs {
  padding: 10px 26px;
  background: #1a3a5c;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: background-color 0.2s;
}

.RegisterSede_btnNext__lEJVs:hover {
  background: #142e4a;
}

.RegisterSede_btnSubmit__Dg6hf {
  padding: 10px 26px;
  background: #2db899;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: background-color 0.2s;
}

.RegisterSede_btnSubmit__Dg6hf:hover {
  background: #25a085;
}

/* ── Responsive ── */
@media (max-width: 768px) {
  .RegisterSede_formGrid__NPv7b {
    grid-template-columns: repeat(2, 1fr);
  }

  .RegisterSede_card__Uzi45 {
    padding: 24px 20px;
  }

  .RegisterSede_stepLine__ddv1n {
    width: 32px;
  }
}

@media (max-width: 480px) {
  .RegisterSede_formGrid__NPv7b,
  .RegisterSede_formGrid2__AltT- {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/RegisterSede/RegisterSede.module.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd;;+BAE6B;EAE7B,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF","sourcesContent":["/* RegisterSede.module.css */\n\n.page {\n  min-height: 100vh;\n  background-color: #f0f4f8;\n  padding-top: 64px;\n}\n\n/* ── Header ── */\n.pageHeader {\n  background: #ffffff;\n  border-bottom: 1px solid #e4e7ec;\n  padding: 16px 20px;\n}\n\n.headerInner {\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.breadcrumb {\n  font-size: 13px;\n  color: #98a2b3;\n  margin-bottom: 8px;\n}\n\n.breadcrumb a {\n  color: #98a2b3;\n  text-decoration: none;\n}\n\n.breadcrumb span {\n  color: #344054;\n  font-weight: 500;\n}\n\n.headerRow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 4px;\n}\n\n.headerLeft h1 {\n  font-size: 1.9rem;\n  font-weight: 700;\n  color: #1a3a5c;\n  margin: 0 0 4px;\n}\n\n.headerLeft p {\n  font-size: 14px;\n  color: #667085;\n  margin: 0;\n}\n\n.loginHint {\n  font-size: 14px;\n  color: #667085;\n  white-space: nowrap;\n}\n\n.loginHint a {\n  color: #1a3a5c;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.loginHint a:hover {\n  text-decoration: underline;\n}\n\n/* ── Stepper ── */\n.stepper {\n  display: flex;\n  align-items: center;\n  margin-top: 16px;\n}\n\n.stepItem {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: #98a2b3;\n  font-weight: 500;\n}\n\n.stepItem.active {\n  color: #1a3a5c;\n  font-weight: 600;\n}\n\n.stepCircle {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: 2px solid #d0d5dd;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 700;\n  color: #98a2b3;\n  background: #fff;\n  flex-shrink: 0;\n}\n\n.stepItem.active .stepCircle,\n.stepItem.done .stepCircle {\n  background: #2db899;\n  border-color: #2db899;\n  color: #fff;\n}\n\n.stepLine {\n  width: 60px;\n  height: 2px;\n  background: #d0d5dd;\n  margin: 0 8px;\n}\n\n.stepLine.doneLine {\n  background: #2db899;\n}\n\n/* ── Contenido ── */\n.content {\n  max-width: 900px;\n  margin: 36px auto;\n  padding: 0 20px;\n  box-sizing: border-box;\n}\n\n/* ── Card ── */\n.card {\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);\n  padding: 32px 36px;\n  box-sizing: border-box;\n}\n\n.stepLabel {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  color: #2db899;\n  margin-bottom: 4px;\n}\n\n.cardTitle {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #1a3a5c;\n  margin-bottom: 4px;\n}\n\n.cardSubtitle {\n  font-size: 13px;\n  color: #667085;\n  margin-bottom: 24px;\n}\n\n/* ── Grid ── */\n.formGrid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px 14px;\n  margin-bottom: 24px;\n}\n\n.formGrid2 {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px 14px;\n  margin-bottom: 24px;\n}\n\n.fieldFull {\n  grid-column: 1 / -1;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.fieldHalf {\n  grid-column: span 2;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n/* ── Inputs ── */\n.label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.8px;\n  text-transform: uppercase;\n  color: #667085;\n}\n\n.input {\n  height: 40px;\n  padding: 0 12px;\n  border: 1.5px solid #d0d5dd;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #344054;\n  background: #fff;\n  outline: none;\n  width: 100%;\n  box-sizing: border-box;\n  transition: border-color 0.2s;\n  font-family: inherit;\n}\n\n.input:focus {\n  border-color: #1a3a5c;\n}\n\n.input::placeholder {\n  color: #b0b8c4;\n}\n\n.select {\n  height: 40px;\n  padding: 0 10px;\n  border: 1.5px solid #d0d5dd;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #344054;\n  background: #fff\n    url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8'%3E%3Cpath d='M0 0l6 8 6-8z' fill='%2398a2b3'/%3E%3C/svg%3E\")\n    no-repeat right 12px center;\n  -webkit-appearance: none;\n  appearance: none;\n  outline: none;\n  width: 100%;\n  box-sizing: border-box;\n  cursor: pointer;\n  transition: border-color 0.2s;\n  font-family: inherit;\n}\n\n.select:focus {\n  border-color: #1a3a5c;\n}\n\n/* ── Password ── */\n.passwordWrap {\n  position: relative;\n}\n\n.passwordWrap .input {\n  padding-right: 40px;\n}\n\n.eyeBtn {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #98a2b3;\n  padding: 0;\n  display: flex;\n  align-items: center;\n}\n\n/* ── Nota ── */\n.required {\n  font-size: 12px;\n  color: #98a2b3;\n  margin-bottom: 0;\n}\n\n/* ── Checkbox ── */\n.checkRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  color: #344054;\n}\n\n.checkRow input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: #2db899;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.checkRow a {\n  color: #2db899;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n/* ── Footer de card ── */\n.cardFooter {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 28px;\n}\n\n.cardFooterRight {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n/* ── Botones ── */\n.btnBack {\n  padding: 10px 20px;\n  border: 1.5px solid #d0d5dd;\n  border-radius: 8px;\n  background: transparent;\n  color: #344054;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: border-color 0.2s;\n}\n\n.btnBack:hover {\n  border-color: #1a3a5c;\n  color: #1a3a5c;\n}\n\n.btnNext {\n  padding: 10px 26px;\n  background: #1a3a5c;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: background-color 0.2s;\n}\n\n.btnNext:hover {\n  background: #142e4a;\n}\n\n.btnSubmit {\n  padding: 10px 26px;\n  background: #2db899;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: background-color 0.2s;\n}\n\n.btnSubmit:hover {\n  background: #25a085;\n}\n\n/* ── Responsive ── */\n@media (max-width: 768px) {\n  .formGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .card {\n    padding: 24px 20px;\n  }\n\n  .stepLine {\n    width: 32px;\n  }\n}\n\n@media (max-width: 480px) {\n  .formGrid,\n  .formGrid2 {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `RegisterSede_page__9fOu7`,
	"pageHeader": `RegisterSede_pageHeader__mYSiM`,
	"headerInner": `RegisterSede_headerInner__ZUzf8`,
	"breadcrumb": `RegisterSede_breadcrumb__RJLZf`,
	"headerRow": `RegisterSede_headerRow__ESA1o`,
	"headerLeft": `RegisterSede_headerLeft__seBVr`,
	"loginHint": `RegisterSede_loginHint__LKQ68`,
	"stepper": `RegisterSede_stepper__mgDaT`,
	"stepItem": `RegisterSede_stepItem__7JE4k`,
	"active": `RegisterSede_active__WNBEi`,
	"stepCircle": `RegisterSede_stepCircle__CD2Zd`,
	"done": `RegisterSede_done__Z4NWv`,
	"stepLine": `RegisterSede_stepLine__ddv1n`,
	"doneLine": `RegisterSede_doneLine__Q9mKv`,
	"content": `RegisterSede_content__Q-7JS`,
	"card": `RegisterSede_card__Uzi45`,
	"stepLabel": `RegisterSede_stepLabel__i9cn+`,
	"cardTitle": `RegisterSede_cardTitle__ZWZk8`,
	"cardSubtitle": `RegisterSede_cardSubtitle__ONRnT`,
	"formGrid": `RegisterSede_formGrid__NPv7b`,
	"formGrid2": `RegisterSede_formGrid2__AltT-`,
	"fieldFull": `RegisterSede_fieldFull__nTUpz`,
	"field": `RegisterSede_field__pnQG1`,
	"fieldHalf": `RegisterSede_fieldHalf__hFSur`,
	"label": `RegisterSede_label__XoRzN`,
	"input": `RegisterSede_input__UNLk8`,
	"select": `RegisterSede_select__oKoCS`,
	"passwordWrap": `RegisterSede_passwordWrap__ycf3w`,
	"eyeBtn": `RegisterSede_eyeBtn__nxRz8`,
	"required": `RegisterSede_required__a8s6G`,
	"checkRow": `RegisterSede_checkRow__7BgjD`,
	"cardFooter": `RegisterSede_cardFooter__PuRqW`,
	"cardFooterRight": `RegisterSede_cardFooterRight__coD02`,
	"btnBack": `RegisterSede_btnBack__6Bpb4`,
	"btnNext": `RegisterSede_btnNext__lEJVs`,
	"btnSubmit": `RegisterSede_btnSubmit__Dg6hf`
};
export default ___CSS_LOADER_EXPORT___;
